@if (isLoading()) {
  <div class="page-loader">
    <div class="loader"></div>
  </div>
  <!-- <div class="page-loader with-text">
    <div class="spinner"></div>
    <p>Loading content please wait...</p>
    <h2>Page Loading</h2>
  </div> -->
}
